import { get } from 'lodash';

export const getUserName = (state) => get(state?.login, 'userInfo.username', null);
